module.exports = __webpack_public_path__ + "static/media/191EC145.a7430162.jpeg";